<template>
    <!--弹窗-->
    <el-dialog
        width="700px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="10vh"
    >

        
        <el-table :data="list" size="mini" border>
            <el-table-column label="广告组" min-width="140" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.ad_group_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="箱数" min-width="60" align="center">
                <template slot-scope="scope">
                    <el-input-number
                        v-model="scope.row.ad_group_num"
                        :min="1"
                        size="mini"
                    ></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="primary"
                @click="onExcel()"
                >生成Excel</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import { binary_download } from "@/utils/method";
export default {
    data() {
        return {};
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        isNew: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        //生成Excel
        onExcel() {
            let AdGroupListOjb = {};
            AdGroupListOjb.ad_group_data = [];
            for (let i = 0; i < this.list.length; i++) {
                let obj = {
                    portfolio_id: this.formData.portfolio_id,
                    sku: this.formData.sku,
                    campaign_daily_budget: this.formData.campaign_daily_budget,
                    max_bid: this.formData.max_bid,
                    ad_goal: this.formData.ad_goal,
                    model: this.formData.model,
                    ad_group_name: this.list[i].ad_group_name,
                    ad_group_num: this.list[i].ad_group_num
                };
                AdGroupListOjb.ad_group_data.push(obj);
            }
            binary_download(
                this.isNew
                    ? "/apis/open_ad_group/batch_open_ad_group_new"
                    : "/apis/open_ad_group/batch_open_ad_group",
                "post",
                {},
                AdGroupListOjb,
                "application/vnd.ms-excel",
                `批量开广告组表格.xlsx`
            );
            this.handleClose();
        },
        // 关闭弹窗
        handleClose() {
            this.$emit("close-callback");
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped></style>
